import { StatusUIType } from 'sections/LKSection/shared/components/UI/Status/Status'
import { PickPointType } from 'sections/LKSection/shared/PickPointSharedModule/types'
import { BaseOption, Country } from 'shared/types/types'

import { ElockReason } from '../ELockModule/types'
import { CouriersAccess, OrderStatus, PickPointLocation } from './types'

export const enum OrderKeys {
  shared = 'shared',

  orderModule = 'orderModule',
  orderPage = 'orderModule.orderPage',
  createOrderPage = 'orderModule.createOrderPage',
  requirementsStep = 'orderModule.createOrderPage.requirementsStep',
  locationStep = 'orderModule.createOrderPage.locationStep',
  workConditionsStep = 'orderModule.createOrderPage.workConditionsStep',
  filesStep = 'orderModule.createOrderPage.filesStep',
  activateOrderPage = 'orderModule.activateOrderPage',
  orderItemPage = 'orderModule.orderItemPage',

  eLockModule = 'eLockModule',
}

export const entranceItems = [PickPointLocation.firstLine, PickPointLocation.inTheYards]

export const pickPointLocationLabels = {
  [PickPointLocation.none]: '',
  [PickPointLocation.firstLine]: 'Первая линия',
  [PickPointLocation.inTheYards]: 'Во дворах',
  [PickPointLocation.plinth]: 'Цоколь',
  [PickPointLocation.shoppingMall]: 'Торговый Центр',
  [PickPointLocation.secondFloor]: '2 этаж',
  [PickPointLocation.firstFloor]: '1 этаж',
  [PickPointLocation.cellar]: 'Подвал',
}

export const floorItems = [PickPointLocation.firstFloor, PickPointLocation.plinth]
export const couriersAccessItems = [CouriersAccess.fulltime, CouriersAccess.openingHours, CouriersAccess.night]

export const orderStatusTranslator: Record<OrderStatus, { title: string; type: StatusUIType }> = {
  [OrderStatus.draft]: { title: 'Черновик', type: StatusUIType.gray },
  [OrderStatus.created]: { title: 'Отправлена', type: StatusUIType.gray },
  [OrderStatus.accepted]: { title: 'Одобрена', type: StatusUIType.corp },
  [OrderStatus.pickPointCreated]: { title: 'ПВЗ активирован', type: StatusUIType.green },
  [OrderStatus.canceled]: { title: 'Отменена', type: StatusUIType.red },
  [OrderStatus.remarkFromActivate]: { title: 'На доработке', type: StatusUIType.red },
  [OrderStatus.remarkFromCreated]: { title: 'На доработке', type: StatusUIType.red },
  [OrderStatus.readyActivate]: { title: 'Отправлена на активацию', type: StatusUIType.corp },
  [OrderStatus.declined]: { title: 'Отклонена', type: StatusUIType.red },
  [OrderStatus.waitingPayment]: { title: 'Ожидает оплаты', type: StatusUIType.orange },
  [OrderStatus.notPaid]: { title: 'Отклонена', type: StatusUIType.red },
  [OrderStatus.remarkFromPayment]: { title: 'Есть замечания', type: StatusUIType.red },
  [OrderStatus.deleted]: { title: 'Удалена', type: StatusUIType.red },
}

export const pickPointTypeOptions: Array<BaseOption<PickPointType> & { className: string }> = [
  { label: 'Упрощенный', value: PickPointType.folk, className: 'folkType' },
  { label: 'Стандартный', value: PickPointType.partner, className: 'partnerType' },
]

export const pointTypeLabels = {
  [PickPointType.folk]: 'Упрощенный',
  [PickPointType.partner]: 'Стандартный',
  [PickPointType.none]: 'Нет',
}

export const timetableGeneralOptions = [
  { value: '09:00-21:00', label: '09:00-21:00' },
  { value: '10:00-22:00', label: '10:00-22:00' },
]

export const eLockReasonOptions = [
  { value: ElockReason.glassDoor, label: 'Неподходящая дверь' },
  { value: ElockReason.northernRegion, label: 'Низкие температуры' },
  { value: ElockReason.other, label: 'Другая причина' },
]

export const regionsWithReferralCode = [
  'Москва',
  'Санкт-Петербург',
  'Московская область',
  'Калининградская область',
  'Ленинградская область',
]

export const subsidySumKey = {
  [Country.RU]: 'SUBSIDY_SINGLE_SUM_RU',
  [Country.GE]: 'SUBSIDY_SINGLE_SUM_GE',
  [Country.AM]: '',
  [Country.KZ]: '',
  [Country.UZ]: '',
  [Country.BY]: '',
  [Country.KG]: '',
  [Country.TJ]: '',
  [Country.TM]: '',
}

export const countriesWithSubsidy = [Country.RU, Country.GE]
